<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item v-if="cliente" :disabled="!isUbico">
          <v-list-item-content>
            <v-list-item-title>
              <v-select :items="itemsRivenditori" label="Rivenditore" item-text="ragioneSociale" item-value="codice" v-model="cliente.reseller" @change="onChageReseller"></v-select>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="item in clienteItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" @change="componentValueChange" :disabled="readOnly"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-btn color="success mb-2" @click="onSalva">Salva</v-btn>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import { rivenditore } from '@/mixins/rivenditore.js'
import configurazioni from '@/services/backofficeService'
import rivenditori from '@/services/rivenditoriService'
import pTesto from '@/views/drawer/elementi/testo'
// import pMultiselect from '@/views/drawer/elementi/multiselect'
import pSwitch from '@/views/drawer/elementi/switch'

export default {
  components: {
    pTesto,
    // pMultiselect,
    pSwitch
  },
  mixins: [
    rivenditore
  ],
  data: () => ({
    backoffice: null,
    show: false,
    locCliente: null,
    formFieldsValid: true,
    boClienti: [
      {
        model: 'codice',
        valueField: 'codice',
        label: 'Codice',
        type: 'Testo',
        required: true,
        maxlength: 30,
        nospaces: true,
        setristretto: true
      },
      {
        model: 'ragioneSociale',
        valueField: 'ragioneSociale',
        label: 'Ragione sociale',
        type: 'Testo',
        required: true
      }],
      itemsRivenditori: [],
      triggerUpdates: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    const elenco = await rivenditori.getRivenditori()
    this.itemsRivenditori = _.sortBy(elenco, ["ragioneSociale"])
  },
  watch: {
    cliente(value) {
      this.locCliente = value
    }
  },
  computed: {
    isUbico() {
      const utente = this.$store.getters['utenti/user']
      return utente && utente.company === 'ubico'
    },
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza cliente'
      } else {
        // return this.locCliente && this.locCliente._id ? 'Modifica cliente' : 'Nuovo cliente'
        return this.locCliente && this.locCliente.codice ? 'Modifica cliente' : 'Nuovo cliente'
      }
    }, 
    drawerSubtitle() {
      return this.locCliente ? `${this.locCliente.codice} - ${this.locCliente.ragioneSociale}` : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    cliente() {
      return this.$store.getters['clienti/cliente'] || null // || { codice: '', descrizione: '' }
    },
    clienteItems() {
      if (!this.locCliente || !this.backoffice || !this.triggerUpdates) {
        return []
      }
      const vars = this.backoffice.clienti
      const items = []
      for (const item of vars) {
        let itemCliente = { value: dot.pick(item.valueField, this.locCliente), ...item }
        if (item.prefix) {
          let prefix = this.getUserPrefix(item.prefix)
          if (this.isUbico) {
            prefix = _.get(this.locCliente, 'prefissoDb', '')
            if (prefix) {
              prefix += '_'
            }
          }
          itemCliente.prefix = prefix
          itemCliente.value = itemCliente.value.substring(prefix.length)
        }
        items.push(itemCliente)
      }
      return items
    }
  },
  methods: {
    onChageReseller(data) {
      const rivenditore = this.itemsRivenditori.find(x => x.codice === data)
      this.locCliente.prefissoDb = rivenditore.prefissoDb
      this.triggerUpdates++
    },
    componentValueChange(data) {
      const { model, subModel, value } = data
      let tgt = {}
      if (subModel) {
        dot.str(model, value[subModel], tgt)
      } else {
        dot.str(model, value, tgt)
      }
      _.merge(this.locCliente, tgt)
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('clienti/SET_REFRESH')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.$store.commit('clienti/SET_CLIENTE', this.locCliente)
        this.$store.commit('clienti/SET_CLIENTE_SAVED')
      }
    }
  }
}
</script>